import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../../shared/Errors/InvalidParamsSharedError.js'

export class SeoScriptValueObject extends ValueObject {
  #innerHTML
  #type

  constructor({innerHTML, type}) {
    super()
    this.#innerHTML = innerHTML
    this.#type = type
  }

  static validate({innerHTML, type}) {
    if (!innerHTML) throw InvalidParamsSharedError.create('[SeoScriptValueObject] innerHTML is required')
    if (!type) throw InvalidParamsSharedError.create('[SeoScriptValueObject] type is required')
  }

  static create({innerHTML, type}) {
    SeoScriptValueObject.validate({innerHTML, type})
    return new SeoScriptValueObject({innerHTML, type})
  }

  get innerHTML() {
    return this.#innerHTML
  }

  get type() {
    return this.#type
  }

  get value() {
    return {
      innerHTML: this.#innerHTML,
      type: this.#type
    }
  }
}
